import { round } from "@turf/turf";
import { differenceInMinutes, format, parseISO } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import { tumBetweenDatetimes } from "../services/tumApi";

export const getGpsGateEquipmentTags = async (gps_app_id) => {
  try {
    const res = await fetch(
      `https://simplefms.io/comGpsGate/api/v.1/applications/${gps_app_id}/tags?FromIndex=0&PageSize=1000`,
      {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization:
            "OQ%2fFQnZx6u6sXu42wCUUknSl19cOtHJknBJw8m6e89vYMr2su0pCOrEtUbrCDTvB",
        },
      }
    );

    const data = await res.json();
    return data;
  } catch (err) {
    console.error("Error al cargar grupos de geocercas:", err);
    return null;
  }
};

export const formatGmtDatetime = (dateString, gmtOffset) => {
  try {
    const date = parseISO(dateString);
    const offset = gmtOffset * -1;
    const timeZone = `Etc/GMT${offset >= 0 ? "+" + offset : offset}`;
    const time = formatInTimeZone(date, timeZone, "HH:mm:ss");
    const dateShift = formatInTimeZone(date, timeZone, "yyyy-MM-dd");
    const fullDatetime = formatInTimeZone(
      date,
      timeZone,
      "yyyy-MM-dd HH:mm:ss"
    );
    const dateHourShift = formatInTimeZone(date, timeZone, "MMM-dd HH:mm:ss");
    return {
      date: dateShift,
      time,
      datetime: fullDatetime,
      dateHourShift: dateHourShift,
    };
  } catch (error) {
    console.error("Error al formatear fecha:", error);
    return null;
  }
};

export const checkConnectEquipment = (dateString) => {
  try {
    const date = parseISO(dateString);
    const nowUtc = new Date();
    const diffMinutes = differenceInMinutes(nowUtc, date);
    const diffHoursFloat = diffMinutes / 60;
    //console.log("Diferencia en horas:", diffHoursFloat);
    return diffHoursFloat;
  } catch (error) {
    console.error("Error al formatear fecha:", error);
    return null;
  }
};

export const getGpsGateUser = async (app_gps_id, gmt_hour) => {
  let equipment_info_list = [];
  try {
    const all_tags = await getGpsGateEquipmentTags(app_gps_id);
    const equipmentsFilter = all_tags.filter((tag) => tag.name === "Principal");

    const truckFilter =
      all_tags.find((tag) => tag.name === "Truck" || tag.name === "Camion")
        ?.usersIds || [];
    const shovelFilter =
      all_tags.find((tag) => tag.name === "Shovel" || tag.name === "Carguio")
        ?.usersIds || [];
    const dozerFilter =
      all_tags.find((tag) => tag.name === "Dozer")?.usersIds || [];
    const graderFilter =
      all_tags.find((tag) => tag.name === "Grader")?.usersIds || [];

    if (!equipmentsFilter.length) return [];

    const equipment_list = equipmentsFilter[0].usersIds || [];

    for (let i = 0; i < equipment_list.length; i++) {
      const response = await fetch(
        `https://simplefms.io/comGpsGate/api/v.1/applications/${app_gps_id}/users/${equipment_list[i]}/status`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "OQ%2fFQnZx6u6sXu42wCUUknSl19cOtHJknBJw8m6e89vYMr2su0pCOrEtUbrCDTvB",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('LOG OPERATOR ', data)

      // Transformar variables en objeto { name: variable }
      const objVariable =
        data.variables?.reduce((acc, item) => {
          acc[item.name] = item;
          return acc;
        }, {}) || {};

      const resultFormatDatetimeUTC = await formatGmtDatetime(
        data.utc,
        gmt_hour
      );
      const resultFormatDatetimeDA = await formatGmtDatetime(
        data.deviceActivity,
        gmt_hour
      );
      const differenceTimeFilter = await checkConnectEquipment(data.utc);

      // Valores seguros con fallback
      const movementValue = objVariable.Movement?.value ?? "False";
      const ignitionValue = objVariable.Ignition?.value ?? "False";
      const speedEquipment = data.velocity?.groundSpeed ?? 0;

      //DEBO CHECKEAR QUE EL TIEMPO DE LAST SEEN Y LAST CONNECT SEAN CERCANOS AL TIEMPO ACTUAL
      let statusEquipment;
      if (
        movementValue === "True" &&
        ignitionValue === "True" &&
        speedEquipment > 0 &&
        differenceTimeFilter < 10
      ) {
        statusEquipment = 1;
      } else if (
        movementValue === "True" &&
        ignitionValue === "True" &&
        speedEquipment <= 0 &&
        differenceTimeFilter < 10
      ) {
        statusEquipment = 4;
      } else if (
        movementValue === "False" &&
        ignitionValue === "True" &&
        speedEquipment <= 0 &&
        differenceTimeFilter < 10
      ) {
        statusEquipment = 2;
      } else if (
        movementValue === "False" &&
        ignitionValue === "False" &&
        speedEquipment <= 0 &&
        differenceTimeFilter < 10
      ) {
        statusEquipment = 3;
      } else if (differenceTimeFilter >= 10) {
        statusEquipment = 5;
      } else {
        statusEquipment = 0;
      }

      let errorDatetime = false;
      if (
        data.utc == "0001-01-01T00:00:00" ||
        data.deviceActivity == "0001-01-01T00:00:00"
      ) {
        errorDatetime = true;
      }
      let typeEquipment = "Other";
      if (truckFilter.includes(data.id)) {
        typeEquipment = "Truck";
      }
      if (shovelFilter.includes(data.id)) {
        typeEquipment = "Shovel";
      }
      if (dozerFilter.includes(data.id)) {
        typeEquipment = "Dozer";
      }
      if (graderFilter.includes(data.id)) {
        typeEquipment = "Grader";
      }

      equipment_info_list.push({
        id: data.id,
        name: data.name,
        trackPoint: data.position,
        velocity: data.velocity,
        utc: resultFormatDatetimeUTC.time,
        utcDate: resultFormatDatetimeUTC.date,
        utcDatetime: resultFormatDatetimeUTC.datetime,
        utcHourDatetime: resultFormatDatetimeUTC.dateHourShift,
        deviceActivity: resultFormatDatetimeDA.time,
        deviceActivityDate: resultFormatDatetimeDA.date,
        deviceActivityDatetime: resultFormatDatetimeDA.datetime,
        deviceActivityHourDatetime: resultFormatDatetimeDA.dateHourShift,
        statusEquipment,
        variables: objVariable,
        errorDatetime,
        typeEquipment: typeEquipment,
      });
    }

    return equipment_info_list;
  } catch (error) {
    //console.error("Error al obtener usuario de GpsGate:", error);
    return [];
  }
};

const transformDatetimeAPI = async (start_date, end_date) => {
  //console.log("La hora de inicio es: ", start_date);
  //console.log("La hora de fin es:", end_date);

  let return_value = null;

  const st = new Date(start_date);
  const et = new Date(end_date);

  // Extraer valores de inicio
  let st_year = st.getFullYear();
  let st_month = String(st.getMonth() + 1).padStart(2, "0");
  let st_day = String(st.getDate()).padStart(2, "0");
  let st_hour = String(st.getHours()).padStart(2, "0");
  let st_minutes = String(st.getMinutes()).padStart(2, "0");

  // Extraer valores de fin
  let et_year = et.getFullYear();
  let et_month = String(et.getMonth() + 1).padStart(2, "0");
  let et_day = String(et.getDate()).padStart(2, "0");
  let et_hour = String(et.getHours()).padStart(2, "0");
  let et_minutes = String(et.getMinutes()).padStart(2, "0");

  //console.log("Hora fin (minutos):", et_minutes);

  // Comparación de fechas
    //console.log("Mismo día: solo se filtra un día");
    return_value = {
      date: `${st_year}-${st_month}-${st_day}`,
      hour_start: st_hour,
      hour_end: et_hour,
      minutes_start: st_minutes,
      minutes_end: et_minutes,
      initial_datetime: `${st_year}-${st_month}-${st_day} ${st_hour}:${st_minutes}:00.000`,
      end_datetime: `${et_year}-${et_month}-${et_day} ${et_hour}:${et_minutes}:00.000`,
    };


  return return_value;
};

const convertUTCWithFixedOffset = (utcString, offsetHours) => {
  const date = new Date(utcString);
  if (isNaN(date.getTime())) {
    throw new Error("utcString no es un formato válido");
  }

  // Extraer componentes UTC
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth(); // 0-11
  const day = date.getUTCDate();
  const hour = date.getUTCHours();
  const minute = date.getUTCMinutes();
  const second = date.getUTCSeconds();

  // Aplicar offset directo
  const localDate = new Date(
    Date.UTC(
      year,
      month,
      day,
      hour + offsetHours, // aplicar offset aquí
      minute,
      second
    )
  );

  // Formatear con ceros
  const fYear = localDate.getUTCFullYear();
  const fMonth = String(localDate.getUTCMonth() + 1).padStart(2, "0");
  const fDay = String(localDate.getUTCDate()).padStart(2, "0");
  const fHour = String(localDate.getUTCHours()).padStart(2, "0");
  const fMinute = String(localDate.getUTCMinutes()).padStart(2, "0");
  const fSecond = String(localDate.getUTCSeconds()).padStart(2, "0");

  return `${fYear}-${fMonth}-${fDay}T${fHour}:${fMinute}:${fSecond}`;
};

const transformacionDataReplay = async (track_replay_info) => {
  //console.log("Entro a funcion transformacion");

  if (!track_replay_info || track_replay_info.length === 0) return [];

  let last_status = track_replay_info[0].status_equipment;
  let initial_datetime = track_replay_info[0].timestamp;
  let trackpoint_list = [];
  let summary_list = [];
  let colour = "white";

  for (let i = 0; i < track_replay_info.length; i++) {
    const current = track_replay_info[i];
    const next = track_replay_info[i + 1];
    const isLast = i === track_replay_info.length - 1;

    // Asignar color
    switch (current.status_equipment) {
      case "Run":
        colour = "green";
        break;
      case "Parked":
        colour = "red";
        break;
      case "Idle":
        colour = "blue";
        break;
      default:
        colour = "black";
        break;
    }

    trackpoint_list.push(current);

    const nextStatus = next ? next.status_equipment : null;

    // Detectar cambio de estado o fin de lista
    if (nextStatus !== last_status || isLast) {
      summary_list.push({
        last_status,
        initial_datetime,
        intial_datetimeUnix: new Date(initial_datetime).getTime(),
        end_datetime: next ? next.timestamp : current.timestamp, // ✅ usa el timestamp del NUEVO estado
        end_datetimeUnix: new Date(
          next ? next.timestamp : current.timestamp
        ).getTime(),
        trackpoint_list: [...trackpoint_list],
        colour,
      });

      // Preparar siguiente bloque si hay un cambio
      if (next) {
        last_status = nextStatus;
        initial_datetime = next.timestamp; // ✅ el nuevo bloque inicia justo en el cambio
        trackpoint_list = [];
      }
    }
  }

  return summary_list;
};

const selectCategoryGpsPoint = async (gpsPoint) => {
  var status_equipment = "Other";
  var is_movement = gpsPoint.variables?.movement;
  var speed_value = gpsPoint.variables?.speed;
  if (is_movement == false && speed_value <= 0) {
    status_equipment = "Parked";
  }
  if (is_movement == true && speed_value <= 0) {
    status_equipment = "Idle";
  }
  if (is_movement == true && speed_value > 0) {
    status_equipment = "Run";
  }

  return status_equipment;
};
export const getGpsGateTrackerUserOriginal = async (
  gps_tracker_id,
  gps_tacker_gmt,
  equipment_list_selected,
  initial_date,
  end_date,
  has_tum_replay,
  backend_route,
  app_unit
) => {
  const equipment_list = equipment_list_selected;
  let equipment_track_list = [];
  const color_trackpoint = [
    "#0400e2",
    "#8c00ff",
    "#12c82d",
    "#ff7b00",
    "#00FFFF",
    "#eff61e",
    "#611f67",
    "#481300",
  ];

  let date_api_info = await transformDatetimeAPI(initial_date, end_date);
  var initial_date = date_api_info.date;
  var initial_hour = date_api_info.hour_start;
  var initial_minutes = date_api_info.minutes_start;
  var end_hour = date_api_info.hour_end;
  var end_minutes = date_api_info.minutes_end;

  var speed_transform = 3.6;
  if (app_unit == "imperial") {
    speed_transform = 2.237;
  }

  try {
    //console.log("Entro a llamada getGpsGateTrackerUser");
    for (let i = 0; i < equipment_list.length; i++) {
      var equipment_id = equipment_list[i]?.value;
      var equipment_name = equipment_list[i]?.label;
      var url_api = `https://simplefms.io/comGpsGate/api/v.1/applications/${gps_tracker_id}/users/${equipment_id}/tracks?Date=${initial_date}&From=${initial_hour}%3A${initial_minutes}%3A00&Until=${end_hour}%3A${end_minutes}%3A00&Filtered=true`;
      var response = await fetch(url_api, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "OQ%2fFQnZx6u6sXu42wCUUknSl19cOtHJknBJw8m6e89vYMr2su0pCOrEtUbrCDTvB",
        },
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      var data = await response.json();
      //console.log('Logs Track Replay Sin Procesar', data);
      var coordinates = [];
      console.log('Altitude: ', data);
      for (var x = 0; x < data.length; x++) {
        if (data[x].valid == true) {
          var status_equipment = "Other";
          status_equipment = await selectCategoryGpsPoint(data[x]);
          coordinates.push({
            coor: {
              longitude: data[x].position.longitude,
              latitude: data[x].position.latitude,
            },
            timestamp: convertUTCWithFixedOffset(data[x].utc, gps_tacker_gmt),
            timestampUnix: new Date(
              convertUTCWithFixedOffset(data[x].utc, gps_tacker_gmt)
            ).getTime(),
            trackId: data[x].trackInfoId,
            created_at: convertUTCWithFixedOffset(
              data[x].serverUtc,
              gps_tacker_gmt
            ),
            created_atUnix: new Date(
              convertUTCWithFixedOffset(data[x].serverUtc, gps_tacker_gmt)
            ).getTime(),
            id: equipment_id,
            name: equipment_name,
            externalVoltage: data[x].variables?.externalVoltage,
            batteryVoltage: data[x].variables?.batteryVoltage,
            movement: data[x].variables?.movement,
            satelliteCount: data[x].variables?.satelliteCount,
            ignition: data[x].variables?.ignition,
            speed: round(data[x].variables?.speed * speed_transform),
            totalOdometer: data[x].variables?.totalOdometer,
            longitude: data[x].position?.longitude,
            latitude: data[x].position?.latitude,
            status_equipment: status_equipment,
            color: color_trackpoint[i],
          });
        }
      }

      var result_trackpoint = await transformacionDataReplay(coordinates);

      var list_tum_clean = [];

      if (has_tum_replay) {
        var tum_info = await tumBetweenDatetimes(
          [equipment_name],
          date_api_info.initial_datetime,
          date_api_info.end_datetime,
          backend_route
        );
        //console.log('Logs Track Replay Tum ', tum_info);
        for (var j = 0; j < tum_info?.info_tum.length; j++) {
          var tum_row = tum_info?.info_tum[j];
          var tum_obj_aux = null;
          var initial_date_tum = null;
          var end_date = null;
          if (i == 0 && tum_info?.info_tum.length == 1) {
            initial_date_tum = date_api_info.initial_datetime;
            end_date = date_api_info.end_datetime;
          } else if (i == 0 && tum_info?.info_tum.length > 1) {
            initial_date_tum = date_api_info.initial_datetime;
            end_date = tum_row.end_date;
          } else if (i == tum_info?.info_tum.length - 1) {
            initial_date_tum = tum_row.start_date;
            end_date = date_api_info.end_datetime;
          } else {
            initial_date_tum = tum_row.start_date;
            end_date = tum_row.end_date;
          }
          tum_obj_aux = {
            state_id: tum_row.state_id,
            status: tum_row.time_category_name,
            category: tum_row.category_name,
            reason_name: tum_row.reason_name,
            initial_date: initial_date_tum,
            end_date: end_date,
            duration: tum_row.duration_minutes,
          };
          list_tum_clean.push(tum_obj_aux);
        }
      }

      var obj_aux_by_equipment = {
        id: equipment_id,
        name: equipment_name,
        color: color_trackpoint[i],
        trackPoint: coordinates,
        track_timeline: result_trackpoint,
        tum_timeline: list_tum_clean,
        columns: [
          { accessorKey: "id", header: "id" },
          { accessorKey: "name", header: "Name" },
          {
            accessorKey: "timestamp",
            header: "Timestamp",
            cell: ({ getValue }) => {
              const value = getValue();
              if (!value) return "";
              const time = value.substring(11, 19);
              return <div title={value}>{time}</div>;
            },
          },
          {
            accessorKey: "created_at",
            header: "Created At",
            cell: ({ getValue }) => {
              const value = getValue();
              if (!value) return "";
              const time = value.substring(11, 19);
              return <div title={value}>{time}</div>;
            },
          },
          { accessorKey: "externalVoltage", header: "Ext Voltage" },
          { accessorKey: "batteryVoltage", header: "batteryVoltage" },
          { accessorKey: "movement", header: "movement" },
          { accessorKey: "satelliteCount", header: "Satellite #" },
          { accessorKey: "ignition", header: "ignition" },
          { accessorKey: "speed", header: "Speed" },
          { accessorKey: "totalOdometer", header: "totalOdometer" },
          { accessorKey: "longitude", header: "longitude" },
          { accessorKey: "latitude", header: "latitude" },
        ],
      };

      equipment_track_list.push(obj_aux_by_equipment);
    }
    return {
      tracks: equipment_track_list,
      initial_limit: date_api_info.initial_datetime,
      initial_limitUnix: new Date(date_api_info.initial_datetime).getTime(),
      end_limit: date_api_info.end_datetime,
      end_limitUnix: new Date(date_api_info.end_datetime).getTime(),
    };
  } catch (error) {
    console.error("Error al obtener usuario de GPS Tracker:", error);
    return null;
  }
};

const generateAllDatetimesGpsApi = async (
  initial_date,
  end_date,
  initial_hour,
  initial_minute,
  end_hour,
  end_minute
) => {
  const startDay = new Date(initial_date);
  startDay.setHours(0, 0, 0, 0);

  const endDay = new Date(end_date);
  endDay.setHours(0, 0, 0, 0);

  const days = [];
  let current = new Date(startDay);

  while (current <= endDay) {
    const first = new Date(current);
    const last = new Date(current);

    // Primer día
    if (current.getTime() === startDay.getTime()) {
      first.setHours(initial_hour, initial_minute, 0, 0);
    } else {
      first.setHours(0, 0, 0, 0);
    }

    // Último día
    if (current.getTime() === endDay.getTime()) {
      last.setHours(end_hour, end_minute, 0, 0);
    } else {
      last.setHours(23, 59, 59, 999);
    }

    days.push({ first_date: first, last_date: last });

    current.setDate(current.getDate() + 1);
  }
  return days;
};

export const getGpsGateTrackerUser = async (
  gps_tracker_id,
  gps_tacker_gmt,
  equipment_list_selected,
  initial_date,
  end_date,
  has_tum_replay,
  backend_route,
  app_unit,
  isTwoDays
) => {
  const equipment_list = equipment_list_selected;
  let equipment_track_list = [];
  
  const color_trackpoint = [
    "#0400e2",
    "#8c00ff",
    "#12c82d",
    "#ff7b00",
    "#00FFFF",
    "#eff61e",
    "#611f67",
    "#481300",
  ];

  //Primero revisar si las fechas estan entre dos dias.
  //Si esto no ocurre, no se hace nada extra.
  //Si son dos dias, se debe aplicar la logica en el ciclo for

  var datetime_list = [];
  if (isTwoDays) {
    //console.log("Proceso fechas - Se debe procesar la fecha");
    //console.log("Proceso fechas - ", initial_date);

    let initial_hour = String(initial_date.getHours()).padStart(2, "0");
    let initial_minutes = String(initial_date.getMinutes()).padStart(2, "0");

    let end_hour = String(end_date.getHours()).padStart(2, "0");
    let end_minutes = String(end_date.getMinutes()).padStart(2, "0");

    //console.log("Proceso fechas - hora ", initial_hour);
    //console.log("Proceso fechas - minuto ", initial_minutes);

    //console.log("Proceso fechas - ", end_date);
    //console.log("Proceso fechas - hora ", end_hour);
    //console.log("Proceso fechas - minuto ", end_minutes);

    datetime_list = await generateAllDatetimesGpsApi(
      initial_date,
      end_date,
      initial_hour,
      initial_minutes,
      end_hour,
      end_minutes
    );
  } else {
    datetime_list = [{ first_date: initial_date, last_date: end_date }];
  }

  //console.log("Proceso fechas - Array ", datetime_list);
  //console.log("Proceso fechas - f ", initial_date);
  //console.log("Proceso fechas - f ", end_date);
  
  let date_api_info = await transformDatetimeAPI(datetime_list[0]?.first_date, datetime_list.at(-1)?.last_date);
  //console.log("Proceso fechas transA ", date_api_info);
  var initial_date = date_api_info?.date;

  var speed_transform = 3.6;
  if (app_unit == "imperial") {
    speed_transform = 2.237;
  }

  try {
    //console.log("Entro a llamada getGpsGateTrackerUser");
    
    for (let i = 0; i < equipment_list.length; i++) {
      var equipment_id = equipment_list[i]?.value;
      var equipment_name = equipment_list[i]?.label;
      var data_tracks = [];

      for (const actual_datetime of datetime_list) {
        //console.log("Proceso fechas for ", actual_datetime);
        let date_api_infoA = await transformDatetimeAPI(actual_datetime?.first_date, actual_datetime?.last_date);
        var initial_dateA = date_api_infoA.date;
        var initial_hourA = date_api_infoA.hour_start;
        var initial_minutesA = date_api_infoA.minutes_start;
        var end_hourA = date_api_infoA.hour_end;
        var end_minutesA = date_api_infoA.minutes_end;

        var url_api = `https://simplefms.io/comGpsGate/api/v.1/applications/${gps_tracker_id}/users/${equipment_id}/tracks?Date=${initial_dateA}&From=${initial_hourA}%3A${initial_minutesA}%3A00&Until=${end_hourA}%3A${end_minutesA}%3A00&Filtered=true`;
        var response = await fetch(url_api, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "OQ%2fFQnZx6u6sXu42wCUUknSl19cOtHJknBJw8m6e89vYMr2su0pCOrEtUbrCDTvB",
          },
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
        var data = await response.json();
        for (const gps_point of data) {
          data_tracks.push(gps_point)
        }
        
        //console.log("Proceso fechas response ", data);
      }
      //console.log("Proceso fechas full ", data_tracks);

      //console.log('Logs Track Replay Sin Procesar', data);
      
      var coordinates = [];
      console.log('Altitude: ', data);
      for (var x = 0; x < data_tracks.length; x++) {
        if (data_tracks[x].valid == true) {
          var status_equipment = "Other";
          status_equipment = await selectCategoryGpsPoint(data_tracks[x]);
          coordinates.push({
            coor: {
              longitude: data_tracks[x].position.longitude,
              latitude: data_tracks[x].position.latitude,
              heading: data_tracks[x]?.velocity?.heading,
            },
            timestamp: convertUTCWithFixedOffset(data_tracks[x].utc, gps_tacker_gmt),
            timestampUnix: new Date(
              convertUTCWithFixedOffset(data_tracks[x].utc, gps_tacker_gmt)
            ).getTime(),
            trackId: data_tracks[x].trackInfoId,
            created_at: convertUTCWithFixedOffset(
              data_tracks[x].serverUtc,
              gps_tacker_gmt
            ),
            created_atUnix: new Date(
              convertUTCWithFixedOffset(data_tracks[x].serverUtc, gps_tacker_gmt)
            ).getTime(),
            id: equipment_id,
            name: equipment_name,
            externalVoltage: data_tracks[x].variables?.externalVoltage,
            batteryVoltage: data_tracks[x].variables?.batteryVoltage,
            movement: data_tracks[x].variables?.movement,
            satelliteCount: data_tracks[x].variables?.satelliteCount,
            ignition: data_tracks[x].variables?.ignition,
            speed: round(data_tracks[x].variables?.speed * speed_transform),
            totalOdometer: data_tracks[x].variables?.totalOdometer,
            longitude: data_tracks[x].position?.longitude.toFixed(6),
            latitude: data_tracks[x].position?.latitude.toFixed(6),
            altitude: data_tracks[x].position?.altitude,
            status_equipment: status_equipment,
            heading: data_tracks[x]?.velocity?.heading,
            color: color_trackpoint[i],
          });
        }
      }

      var result_trackpoint = await transformacionDataReplay(coordinates);

      var list_tum_clean = [];

      if (has_tum_replay) {
        var tum_info = await tumBetweenDatetimes(
          [equipment_name],
          date_api_info.initial_datetime,
          date_api_info.end_datetime,
          backend_route
        );
        //console.log('Logs Track Replay Tum ', tum_info);
        for (var j = 0; j < tum_info?.info_tum.length; j++) {
          var tum_row = tum_info?.info_tum[j];
          var tum_obj_aux = null;
          var initial_date_tum = null;
          var end_date = null;
          if (i == 0 && tum_info?.info_tum.length == 1) {
            initial_date_tum = date_api_info.initial_datetime;
            end_date = date_api_info.end_datetime;
          } else if (i == 0 && tum_info?.info_tum.length > 1) {
            initial_date_tum = date_api_info.initial_datetime;
            end_date = tum_row.end_date;
          } else if (i == tum_info?.info_tum.length - 1) {
            initial_date_tum = tum_row.start_date;
            end_date = date_api_info.end_datetime;
          } else {
            initial_date_tum = tum_row.start_date;
            end_date = tum_row.end_date;
          }
          tum_obj_aux = {
            state_id: tum_row.state_id,
            status: tum_row.time_category_name,
            category: tum_row.category_name,
            reason_name: tum_row.reason_name,
            initial_date: initial_date_tum,
            end_date: end_date,
            duration: tum_row.duration_minutes,
          };
          list_tum_clean.push(tum_obj_aux);
        }
      }

      var obj_aux_by_equipment = {
        id: equipment_id,
        name: equipment_name,
        color: color_trackpoint[i],
        trackPoint: coordinates,
        track_timeline: result_trackpoint,
        tum_timeline: list_tum_clean,
        columns: [
          { accessorKey: "id", header: "id" },
          { accessorKey: "name", header: "Name", size: 50, },
          {
            accessorKey: "timestamp",
            header: "GPS time",  size: 70,
            cell: ({ getValue }) => {
              const value = getValue();
              const valueMonth = format(value, "MMM-dd-yyyy HH:mm:ss");
              if (!value) return "";
              const time = value.substring(11, 19);
              return <div title={valueMonth}>{time}</div>;
            },
          },
          {
            accessorKey: "created_at",
            header: "Created",  size: 50, 
            cell: ({ getValue }) => {
              const value = getValue();
              if (!value) return "";
              const valueMonth = format(value, "MMM-dd-yyyy HH:mm:ss");
              const time = value.substring(11, 19);
              return <div title={valueMonth}>{time}</div>;
            },
          },
          { accessorKey: "externalVoltage", header: "Ext Volt", size: 50,  },
          { accessorKey: "batteryVoltage", header: "batteryVoltage",  size: 50,  },
          { accessorKey: "movement", header: "movement",  size: 50,  },
          { accessorKey: "satelliteCount", header: "Sat #",  size: 50,  },
          { accessorKey: "ignition", header: "ignition",  size: 50,  },
          { accessorKey: "speed", header: "Speed",  size: 50,  },
          { accessorKey: "totalOdometer", header: "totalOdometer",  size: 50,  },
          { accessorKey: "longitude", header: "Longitude",  size: 70,  },
          { accessorKey: "latitude", header: "Latitude",  size: 70,  },
          { accessorKey: "altitude", header: "Altitude",  size: 70,  },
        ],
      };

      equipment_track_list.push(obj_aux_by_equipment);
    }
    return {
      tracks: equipment_track_list,
      initial_limit: date_api_info.initial_datetime,
      initial_limitUnix: new Date(date_api_info.initial_datetime).getTime(),
      end_limit: date_api_info.end_datetime,
      end_limitUnix: new Date(date_api_info.end_datetime).getTime(),
    };
  } catch (error) {
    console.error("Error al obtener usuario de GPS Tracker:", error);
    return null;
  }
};

export const getGpsGateGeoGroups = async (gps_app_id) => {
  try {
    const res = await fetch(
      `https://simplefms.io/comGpsGate/api/v.1/applications/${gps_app_id}/geofencegroups?FromIndex=0&PageSize=1000`,
      {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization:
            "OQ%2fFQnZx6u6sXu42wCUUknSl19cOtHJknBJw8m6e89vYMr2su0pCOrEtUbrCDTvB",
        },
      }
    );

    const data = await res.json();
    //console.log("info geo: ", data);
    return data;
  } catch (err) {
    //console.error("Error al cargar grupos de geocercas:", err);
    return null;
  }
};

export const getGpsGateGeofences = async (gps_app_id) => {
  try {
    //console.log("Primero se revisan los grupos");
    const all_groups = await getGpsGateGeoGroups(gps_app_id);
    //console.log("Los geogrupos son: ", all_groups);
    const formatted_select = all_groups.map((group) => ({
      label: group.name,
      value: group.id,
    }));
    //console.log(formatted_select);

    var all_info_geofences = [];
    for (const group of all_groups) {
      //console.log(group.name + " - " + group.id + " - " + group.colour);
      const subRes = await fetch(
        `https://simplefms.io/comGpsGate/api/v.1/applications/${gps_app_id}/geofencegroups/${group.id}/geofences`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
            Authorization:
              "OQ%2fFQnZx6u6sXu42wCUUknSl19cOtHJknBJw8m6e89vYMr2su0pCOrEtUbrCDTvB",
          },
        }
      );
      const geofencesInGroup = await subRes.json();
      var aux_geofence_list = [];
      for (const geofence of geofencesInGroup) {
        //console.log(geofence);
        var geo_info = {
          id: geofence.id,
          name: geofence.name,
          type: geofence.shapeType,
          vertices: geofence?.polygonShape?.vertices,
          circleConfig: geofence?.circleShape,
          description: geofence?.description,
          is_active: true,
        };
        aux_geofence_list.push(geo_info);
      }

      var aux_geogrup_obj = {
        groupId: group.id,
        groupName: group.name,
        description: group.description,
        geofenceIds: group.geofenceIds,
        colour: group.colour,
        priority: group.priority,
        useInGeocoding: group.useInGeocoding,
        geofences: aux_geofence_list,
        isVisible: group.pinned,
      };
      all_info_geofences.push(aux_geogrup_obj);
    }

    //console.log("info geo: ", all_info_geofences);
    return {
      status: 200,
      geofenceList: all_info_geofences,
      geoGroupSelect: formatted_select,
    };
  } catch (err) {
    console.error("Error al cargar grupos de geocercas:", err);
    return { status: 400, geofenceList: null, geoGroupSelect: null };
  }
};

const wait = (ms) => new Promise((res) => setTimeout(res, ms));

async function assignGeofenceToGroup(gps_app_id, geo_group, geofenceId) {
  const delays = [0, 500, 1500, 1500];

  for (let i = 0; i < delays.length; i++) {
    if (delays[i] > 0) {
      await wait(delays[i]);
    }

    const res = await fetch(
      `https://simplefms.io/comGpsGate/api/v.1/applications/${gps_app_id}/geofencegroups/${geo_group}/geofences`,
      {
        method: "POST",
        headers: {
          accept: "application/json",
          Authorization:
            "OQ%2fFQnZx6u6sXu42wCUUknSl19cOtHJknBJw8m6e89vYMr2su0pCOrEtUbrCDTvB",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: geofenceId }),
      }
    );

    if (res.ok) {
      //console.log('El ingreso al grupo esta ok')
      return { ok: true };
    }

    const text = await res.text();
    //console.warn(`Asignación intento ${i + 1} falló:`, res.status, text);

    // Si ya sabemos que es el error clásico, seguimos intentando
    if (text.includes("not found")) continue;
  }

  return { ok: false };
}

export const insertNewGeofenceOriginal = async (
  gps_app_id,
  geo_name,
  geo_description,
  geo_group,
  geo_coord
) => {
  let statusInsert = 400;
  let isInsert = false;

  try {
    if (!geo_coord || !geo_coord[0] || geo_coord[0].length < 3) {
      //console.error("Polygon inválido:", geo_coord);
      return { status: 400, isInsert: false };
    }

    const vertices = geo_coord[0].map(([lng, lat]) => ({
      latitude: lat,
      longitude: lng,
    }));

    const longitudes = vertices.map((v) => v.longitude);
    const latitudes = vertices.map((v) => v.latitude);

    const boundingBox = {
      minX: Math.min(...longitudes),
      maxX: Math.max(...longitudes),
      minY: Math.min(...latitudes),
      maxY: Math.max(...latitudes),
    };

    const bodyNewGeofence = {
      shapeType: "Polygon",
      name: geo_name,
      description: geo_description,
      polygonShape: { vertices },
      boundingBox,
      circleShape: { center: { latitude: 0, longitude: 0 }, radius: 0 },
      routeShape: { radius: 0, vertices: [] },
    };

    // 1) Crear geocerca
    const response = await fetch(
      `https://simplefms.io/comGpsGate/api/v.1/applications/${gps_app_id}/geofences`,
      {
        method: "POST",
        headers: {
          accept: "application/json",
          Authorization:
            "OQ%2fFQnZx6u6sXu42wCUUknSl19cOtHJknBJw8m6e89vYMr2su0pCOrEtUbrCDTvB",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyNewGeofence),
      }
    );

    if (!response.ok) {
      //console.error("Error creando geofence:", response.status);
      return { status: response.status, isInsert: false };
    }

    let apiResponse = {};
    try {
      apiResponse = await response.json();
    } catch (error) {
      //console.warn("La API no devolvió JSON válido");
      var aux = 0;
    }

    if (!apiResponse?.id) {
      //console.error("API no retornó ID:", apiResponse);
      return { status: 400, isInsert: false };
    }

    const groupAssign = await assignGeofenceToGroup(
      gps_app_id,
      geo_group,
      apiResponse?.id
    );

    if (groupAssign.ok) {
      statusInsert = 200;
      isInsert = true;
    }
  } catch (err) {
    //console.error("Error al insertar geocerca:", err);
    var auxc = 0;
  }

  return { status: statusInsert, isInsert };
};

export const insertNewGeofence = async (
  gps_app_id,
  geo_name,
  geo_description,
  geo_group,
  geo_coord
) => {
  let statusInsert = 400;
  let isInsert = false;

  try {
    if (!geo_coord || !geo_coord[0] || geo_coord[0].length < 3) {
      //console.error("Polygon inválido:", geo_coord);
      return { status: 400, isInsert: false };
    }

    const vertices = geo_coord[0].map(([lng, lat]) => ({
      latitude: lat,
      longitude: lng,
    }));

    const longitudes = vertices.map((v) => v.longitude);
    const latitudes = vertices.map((v) => v.latitude);

    const boundingBox = {
      minX: Math.min(...longitudes),
      maxX: Math.max(...longitudes),
      minY: Math.min(...latitudes),
      maxY: Math.max(...latitudes),
    };

    const bodyNewGeofence = {
      shapeType: "Polygon",
      name: geo_name,
      description: geo_description,
      polygonShape: { vertices },
      boundingBox,
      circleShape: { center: { latitude: 0, longitude: 0 }, radius: 0 },
      routeShape: { radius: 0, vertices: [] },
    };

    // 1) Crear geocerca
    const response = await fetch(
      `https://simplefms.io/comGpsGate/api/v.1/applications/${gps_app_id}/geofences`,
      {
        method: "POST",
        headers: {
          accept: "application/json",
          Authorization:
            "OQ%2fFQnZx6u6sXu42wCUUknSl19cOtHJknBJw8m6e89vYMr2su0pCOrEtUbrCDTvB",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyNewGeofence),
      }
    );

    if (!response.ok) {
      //console.error("Error creando geofence:", response.status);
      return { status: response.status, isInsert: false };
    }

    let apiResponse = {};
    try {
      apiResponse = await response.json();
    } catch (error) {
      //console.warn("La API no devolvió JSON válido");
      var aux = 0;
    }

    if (!apiResponse?.id) {
      //console.error("API no retornó ID:", apiResponse);
      return { status: 400, isInsert: false };
    }

    const groupAssign = await assignGeofenceToGroup(
      gps_app_id,
      geo_group,
      apiResponse?.id
    );

    if (groupAssign.ok) {
      statusInsert = 200;
      isInsert = true;
    }
  } catch (err) {
    //console.error("Error al insertar geocerca:", err);
    var auxc = 0;
  }

  return { status: statusInsert, isInsert };
};

export const gpsUpdateGeofence = async (
  gps_app_id,
  geofence_id,
  geo_name,
  geo_description,
  geo_group,
  geo_coord,
  change_geo_group,
  old_geo_group
) => {
  var statusUpdate = 400;
  var isUpdated = false;

  try {
    console.log("Entro a funcion UpdateGeofence");
    //console.log(gps_app_id);
    //console.log(geofence_id);
    //console.log(geo_name);
    //console.log(geo_group);
    //console.log(geo_coord);

    const vertices = geo_coord.map(([lng, lat]) => ({
      latitude: lat,
      longitude: lng,
    }));

    //console.log(vertices);
    const longitudes = vertices.map((v) => v.longitude);
    const latitudes = vertices.map((v) => v.latitude);
    const boundingBox = {
      minX: Math.min(...longitudes),
      maxX: Math.max(...longitudes),
      minY: Math.min(...latitudes),
      maxY: Math.max(...latitudes),
    };
    const bodyNewGeofence = {
      id: geofence_id,
      shapeType: "Polygon",
      name: geo_name,
      description: geo_description,
      polygonShape: { vertices },
      boundingBox,
      circleShape: { center: { latitude: 0, longitude: 0 }, radius: 0 },
      routeShape: { radius: 0, vertices: [] },
    };
    //console.log(bodyNewGeofence);

    const response = await fetch(
      `https://simplefms.io/comGpsGate/api/v.1/applications/${gps_app_id}/geofences/${geofence_id}`,
      {
        method: "PUT",
        headers: {
          accept: "application/json",
          Authorization:
            "OQ%2fFQnZx6u6sXu42wCUUknSl19cOtHJknBJw8m6e89vYMr2su0pCOrEtUbrCDTvB",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyNewGeofence),
      }
    );
    //console.log(response);
    const apiResponse = await response.json();
    //console.log(apiResponse);

    if (apiResponse?.id != null) {
      if (change_geo_group) {
        const groupResGeo = await fetch(
          `https://simplefms.io/comGpsGate/api/v.1/applications/${gps_app_id}/geofencegroups/${geo_group}/geofences`,
          {
            method: "POST",
            headers: {
              accept: "application/json",
              Authorization:
                "OQ%2fFQnZx6u6sXu42wCUUknSl19cOtHJknBJw8m6e89vYMr2su0pCOrEtUbrCDTvB",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ id: apiResponse.id }),
          }
        );

        if (groupResGeo.ok) {
          const deleteResGeoGroup = await fetch(
            `https://simplefms.io/comGpsGate/api/v.1/applications/${gps_app_id}/geofencegroups/${old_geo_group}/geofences/${geofence_id}`,
            {
              method: "DELETE",
              headers: {
                accept: "application/json",
                Authorization:
                  "OQ%2fFQnZx6u6sXu42wCUUknSl19cOtHJknBJw8m6e89vYMr2su0pCOrEtUbrCDTvB",
                "Content-Type": "application/json",
              },
            }
          );

          if (deleteResGeoGroup.ok) {
            statusUpdate = 200;
            isUpdated = true;
          }
        }
      } else {
        statusUpdate = 200;
        isUpdated = true;
      }
    }
  } catch (err) {
    console.error("Error al insertar geocerca:", err);
  }
  return { status: statusUpdate, isUpdated: isUpdated };
};

export const gpsUpdateGeoGroup = async (gps_app_id, info_update) => {
  var statusUpdate = 400;
  var isUpdated = false;
  var geoGroupId = info_update.id;

  try {
    //console.log("Entro a gpsUpdateGeoGroup");
    //console.log(info_update);

    const response = await fetch(
      `https://simplefms.io/comGpsGate/api/v.1/applications/${gps_app_id}/geofenceGroups/${geoGroupId}`,
      {
        method: "PUT",
        headers: {
          accept: "application/json",
          Authorization:
            "OQ%2fFQnZx6u6sXu42wCUUknSl19cOtHJknBJw8m6e89vYMr2su0pCOrEtUbrCDTvB",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(info_update),
      }
    );
    //console.log(response);
    const apiResponse = await response.json();

    //console.log("Se cambia la visibilidad 3: ", apiResponse);
    if (apiResponse?.id != null) {
      statusUpdate = 200;
      isUpdated = true;
    }
  } catch (err) {
    var aux_err = null;
    //console.error("Error al insertar geocerca:", err);
  }
  return { status: statusUpdate, isUpdated: isUpdated };
};

export const gpsDeleteGeofence = async (gps_app_id, geo_id) => {
  try {
    console.log("Entro a funcion deleteGeofence");
    //console.log(gps_app_id);
    //console.log(geo_id);

    var statusDelete = 400;

    const deleteRes = await fetch(
      `https://simplefms.io/comGpsGate/api/v.1/applications/${gps_app_id}/geofences/${geo_id}`,
      {
        method: "DELETE",
        headers: {
          accept: "application/json",
          Authorization:
            "OQ%2fFQnZx6u6sXu42wCUUknSl19cOtHJknBJw8m6e89vYMr2su0pCOrEtUbrCDTvB",
          "Content-Type": "application/json",
        },
      }
    );

    if (deleteRes.ok) {
      statusDelete = 200;
    }
  } catch (err) {
    console.error("Error al eliminar geocercas:", err);
  }
  return { status: statusDelete };
};
